import {
  getGridStringOperators,
  GridCellParams,
  GridColDef,
  GridRenderCellParams
} from '@mui/x-data-grid'
import { Link } from 'react-router-dom'
import i18n from 'src/services/language.service'

const filterOperators = getGridStringOperators().filter(({ value }) =>
  ['contains', 'equals', 'startsWith', 'endsWith' /* add more over time */].includes(value)
)

export const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: i18n.t('COMPANY.COMPANY_NAME'),
    editable: false,
    sortable: false,
    flex: 1,
    filterOperators,
    renderCell: (params: GridRenderCellParams) => {
      return <Link to={`/companies/edit/${params.id}`}>{params.formattedValue}</Link>
    }
  },
  {
    field: 'externalId',
    headerName: i18n.t('COMPANY.COMPANY_NUMBER'),
    editable: false,
    sortable: false,
    filterable: true,
    filterOperators,
    flex: 1
  },
  {
    field: 'contractInPlace',
    headerName: i18n.t('COMPANY.CONTRACT_IN_PLACE'),
    editable: false,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: (params: GridCellParams) => {
      return <p>{params.formattedValue ? i18n.t('COMPANY.YES') : i18n.t('COMPANY.NO')}</p>
    },
    getApplyQuickFilterFn: undefined
  },
  {
    field: 'numberOfLocations',
    headerName: i18n.t('COMPANY.NUMBER_OF_LOCATIONS'),
    editable: false,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    flex: 1,
    getApplyQuickFilterFn: undefined
  },
  {
    field: 'numberOfAssociatedPreventiveLogs',
    headerName: i18n.t('COMPANY.NUMBER_OF_PREVENTIVE_LOGS'),
    editable: false,
    sortable: false,
    filterable: true,
    filterOperators,
    flex: 1,
    getApplyQuickFilterFn: undefined
  },
  {
    field: 'actions',
    filterable: false,
    headerName: '',
    editable: false,
    sortable: false,
    flex: 0.5,
    disableColumnMenu: true,
    align: 'right',
    getApplyQuickFilterFn: undefined
  }
]
